import { render, staticRenderFns } from "./ProAlert.vue?vue&type=template&id=b786e03e"
import script from "./ProAlert.vue?vue&type=script&lang=js"
export * from "./ProAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b786e03e')) {
      api.createRecord('b786e03e', component.options)
    } else {
      api.reload('b786e03e', component.options)
    }
    module.hot.accept("./ProAlert.vue?vue&type=template&id=b786e03e", function () {
      api.rerender('b786e03e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/messages/ProAlert.vue"
export default component.exports